<template>
  <section class="admin-content" id="audit-log">
    <Navbar />
    <main class="admin-main">
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3"><i class="fe fe-shield" style="font-size: 22px;"></i></div>
            <div>
              <h4 class="mb-0 font-weight-bold">Audit Log</h4>
              <small style="opacity: 0.8;">Who changed an enrollee's facility, expiry date, HMO or other sensitive details, and when</small>
            </div>
          </div>
        </div>
      </div>
      <section style="margin-top: -20px;">
        <div class="container pb-5">
          <SensitiveChanges :title="isAdmin ? 'Sensitive changes' : 'Sensitive changes you made'" :per-page="30" />
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import SensitiveChanges from "./components/SensitiveChanges.vue";

export default {
  components: { Navbar, SensitiveChanges },
  data() {
    const user = JSON.parse(localStorage.getItem("user") || "{}") || {};
    return { isAdmin: user.type === "shis" || String(user.user_role) === "1" };
  },
};
</script>

<style scoped>
@import "./reports.css";
</style>
